<script setup lang="ts">
import {ColorVariantType} from '@toolify/client/src/modules/ui/enum/ColorVariantType'

interface Props {
  percentage: number
  color?: ColorVariantType
}
withDefaults(defineProps<Props>(), {
  color: ColorVariantType.Primary,
})
</script>

<template>
  <div class="progress" :class="`color-${color}`">
    <div class="bar" :style="{width: `${percentage * 100}%`}"/>
  </div>
</template>

<style scoped lang="scss">
  @use '../../../styles/variables' as variables;

  .progress {
    height: 4px;
    background: map-get(variables.$colors, container-high);
    border-radius: variables.$borderRadius;
  }

  .bar {
    height: 4px;
    background: map-get(variables.$colors, primary);
    border-radius: variables.$borderRadius;
  }

  .color-error .bar {
    background: map-get(variables.$colors, error);
  }
</style>
